export default {
  // Navigation
  'nav.home': 'Inicio',
  'nav.solutions': 'Soluciones',
  'nav.platform': 'Plataforma',
  'nav.about': 'Nosotros',
  'nav.contact': 'Contacto',
  'nav.login': 'Acceso Clientes',
  
  // Hero Section
  'hero.title': 'Potenciando la Atención Médica con Soluciones Digitales Inteligentes',
  'hero.subtitle': 'Guangbao-Uni proporciona plataformas integrales de gestión sanitaria y servicios de interacción de big data para instituciones médicas en todo el mundo, permitiéndoles brindar atención superior a sus pacientes',
  'hero.cta.demo': 'Solicitar Demo',
  'hero.cta.learn': 'Más Información',
  
  // Solutions
  'solutions.title': 'Soluciones Sanitarias Integrales',
  'solutions.subtitle': 'Plataformas integradas diseñadas para transformar la prestación de atención médica',
  'solutions.industry.title': 'Plataforma de Gestión de Aplicaciones Industriales',
  'solutions.industry.desc': 'Optimice las operaciones con nuestro sistema de gestión integral específico de la industria diseñado para proveedores de atención médica',
  'solutions.health.title': 'Plataforma de Salud Integrada',
  'solutions.health.desc': 'Solución unificada de gestión de salud que conecta instituciones médicas con pacientes para una atención fluida',
  'solutions.enterprise.title': 'Plataforma de Gestión Empresarial',
  'solutions.enterprise.desc': 'Plataforma robusta de nivel empresarial para gestionar operaciones y flujos de trabajo sanitarios complejos',
  
  // Features
  'features.title': 'Capacidades de la Plataforma',
  'features.subtitle': 'Características avanzadas para mejorar la prestación de atención médica',
  'features.data.title': 'Análisis de Big Data Médico',
  'features.data.desc': 'Aproveche el análisis de datos potente para obtener información y mejorar los resultados de los pacientes',
  'features.integration.title': 'Integración Perfecta',
  'features.integration.desc': 'Conéctese con sistemas existentes y servicios de terceros sin esfuerzo',
  'features.security.title': 'Seguridad Empresarial',
  'features.security.desc': 'Protocolos de seguridad de nivel bancario para proteger datos médicos sensibles',
  'features.scalability.title': 'Escalabilidad Global',
  'features.scalability.desc': 'Infraestructura en la nube que respalda instituciones sanitarias en todo el mundo',
  'features.compliance.title': 'Cumplimiento Normativo',
  'features.compliance.desc': 'Cumple con estándares y regulaciones sanitarias internacionales',
  'features.support.title': 'Soporte 24/7',
  'features.support.desc': 'Soporte técnico las 24 horas para un servicio ininterrumpido',
  
  // Benefits
  'benefits.title': 'Por Qué Elegir Guangbao-Uni',
  'benefits.subtitle': 'Transforme su institución sanitaria con nuestras soluciones probadas',
  'benefits.efficiency.title': 'Eficiencia Mejorada',
  'benefits.efficiency.desc': 'Automatice flujos de trabajo y reduzca la carga administrativa hasta en un 60%',
  'benefits.patient.title': 'Atención al Paciente Mejorada',
  'benefits.patient.desc': 'Proporcione mejores experiencias a los pacientes mediante gestión de salud integrada',
  'benefits.insights.title': 'Información Basada en Datos',
  'benefits.insights.desc': 'Tome decisiones informadas con análisis e informes completos',
  'benefits.cost.title': 'Reducción de Costos',
  'benefits.cost.desc': 'Optimice la asignación de recursos y reduzca significativamente los costos operativos',
  
  // Stats
  'stats.institutions': 'Instituciones Médicas',
  'stats.countries': 'Países Atendidos',
  'stats.patients': 'Pacientes Gestionados',
  'stats.uptime': 'Tiempo de Actividad del Sistema',
  
  // CTA
  'cta.title': '¿Listo para Transformar su Institución Sanitaria?',
  'cta.subtitle': 'Únase a las principales instituciones médicas de todo el mundo que utilizan las plataformas Guangbao-Uni',
  'cta.button': 'Comience Hoy',
  
  // Footer
  'footer.company': 'Empresa',
  'footer.about': 'Nosotros',
  'footer.careers': 'Carreras',
  'footer.news': 'Noticias',
  'footer.products': 'Productos',
  'footer.industry': 'Plataforma Industrial',
  'footer.health': 'Plataforma de Salud',
  'footer.enterprise': 'Plataforma Empresarial',
  'footer.resources': 'Recursos',
  'footer.documentation': 'Documentación',
  'footer.support': 'Centro de Soporte',
  'footer.blog': 'Blog',
  'footer.legal': 'Legal',
  'footer.privacy': 'Política de Privacidad',
  'footer.terms': 'Términos de Servicio',
  'footer.security': 'Seguridad',
  'footer.rights': '© 2024 Guangbao-Uni. Todos los derechos reservados.',
  'footer.description': 'Proveedor líder de soluciones sanitarias inteligentes y servicios de big data para instituciones médicas en todo el mundo.',
  
  // Contact
  'contact.title': 'Póngase en Contacto',
  'contact.subtitle': 'Nuestro equipo está listo para ayudarle a transformar sus operaciones sanitarias',
  'contact.name': 'Nombre Completo',
  'contact.email': 'Correo Electrónico',
  'contact.company': 'Nombre de la Institución',
  'contact.phone': 'Número de Teléfono',
  'contact.message': 'Mensaje',
  'contact.submit': 'Enviar Mensaje',
  'contact.success': '¡Gracias! Nos pondremos en contacto pronto.',
  
  // Login
  'login.title': 'Acceso al Portal de Clientes',
  'login.subtitle': 'Acceda a su plataforma de gestión sanitaria',
  'login.email': 'Correo Electrónico',
  'login.password': 'Contraseña',
  'login.remember': 'Recuérdame',
  'login.forgot': '¿Olvidó su contraseña?',
  'login.button': 'Iniciar Sesión',
  'login.support': '¿Necesita ayuda? Contacte con soporte',

  // Industry Platform
  'industryPlatform.hero.title': 'Plataforma de Gestión de Aplicaciones Industriales',
  'industryPlatform.hero.subtitle': 'Solución integral de gestión de la industria sanitaria con análisis de datos avanzados, automatización de flujos de trabajo y capacidades de cumplimiento normativo',
  'industryPlatform.hero.exploreFeatures': 'Explorar Características',
  'industryPlatform.hero.contactUs': 'Contáctenos',
  'industryPlatform.features.title': 'Características Principales',
  'industryPlatform.features.subtitle': 'Herramientas potentes diseñadas para la gestión de la industria sanitaria',
  'industryPlatform.features.dataManagement.title': 'Gestión de Datos Médicos',
  'industryPlatform.features.dataManagement.desc': 'Almacenamiento y gestión centralizada de datos médicos con capacidades avanzadas de búsqueda y recuperación',
  'industryPlatform.features.analytics.title': 'Análisis Avanzados',
  'industryPlatform.features.analytics.desc': 'Análisis e informes en tiempo real para la toma de decisiones basada en datos',
  'industryPlatform.features.compliance.title': 'Gestión de Cumplimiento',
  'industryPlatform.features.compliance.desc': 'Garantice el cumplimiento de las regulaciones sanitarias y estándares de la industria',
  'industryPlatform.features.collaboration.title': 'Colaboración Multi-Institucional',
  'industryPlatform.features.collaboration.desc': 'Herramientas de colaboración fluidas para redes y asociaciones sanitarias',
  'industryPlatform.features.customization.title': 'Personalización Flexible',
  'industryPlatform.features.customization.desc': 'Adapte la plataforma a sus requisitos específicos de la industria',
  'industryPlatform.features.cloudBased.title': 'Infraestructura en la Nube',
  'industryPlatform.features.cloudBased.desc': 'Arquitectura basada en la nube segura y escalable para accesibilidad global',
  'industryPlatform.benefits.title': 'Beneficios de la Plataforma',
  'industryPlatform.benefits.subtitle': 'Mejoras medibles para sus operaciones sanitarias',
  'industryPlatform.benefits.efficiency.title': 'Eficiencia Operativa',
  'industryPlatform.benefits.efficiency.desc': 'Optimice procesos y aumente la productividad en toda su organización',
  'industryPlatform.benefits.efficiency.label': 'Aumento de Eficiencia',
  'industryPlatform.benefits.accuracy.title': 'Precisión de Datos',
  'industryPlatform.benefits.accuracy.desc': 'Minimice errores con validación automática y controles de calidad',
  'industryPlatform.benefits.accuracy.label': 'Precisión de Datos',
  'industryPlatform.benefits.cost.title': 'Ahorro de Costos',
  'industryPlatform.benefits.cost.desc': 'Reduzca los costos operativos mediante automatización y optimización',
  'industryPlatform.benefits.cost.label': 'Reducción de Costos',
  'industryPlatform.cta.title': 'Transforme sus Operaciones Sanitarias',
  'industryPlatform.cta.subtitle': 'Descubra cómo nuestra plataforma puede revolucionar la gestión de su industria',
  'industryPlatform.cta.button': 'Programar una Demo',

  // Health Platform
  'healthPlatform.hero.title': 'Plataforma de Salud Integrada',
  'healthPlatform.hero.subtitle': 'Solución unificada de gestión sanitaria que conecta instituciones médicas con pacientes para una atención fluida y mejores resultados de salud',
  'healthPlatform.hero.exploreFeatures': 'Explorar Características',
  'healthPlatform.hero.contactUs': 'Contáctenos',
  'healthPlatform.features.title': 'Características de la Plataforma',
  'healthPlatform.features.subtitle': 'Herramientas integrales para la gestión de salud integrada',
  'healthPlatform.features.patientManagement.title': 'Gestión de Pacientes',
  'healthPlatform.features.patientManagement.desc': 'Gestión completa de información de pacientes con registros de salud unificados',
  'healthPlatform.features.appointment.title': 'Programación de Citas',
  'healthPlatform.features.appointment.desc': 'Sistema de programación inteligente para una gestión eficiente de citas',
  'healthPlatform.features.telemedicine.title': 'Servicios de Telemedicina',
  'healthPlatform.features.telemedicine.desc': 'Capacidades de consulta remota y prestación de atención virtual',
  'healthPlatform.features.ehr.title': 'Registros de Salud Electrónicos',
  'healthPlatform.features.ehr.desc': 'Registros de salud digitales seguros y completos accesibles en cualquier momento',
  'healthPlatform.features.prescription.title': 'Receta Electrónica',
  'healthPlatform.features.prescription.desc': 'Gestión de recetas digitales e integración con farmacias',
  'healthPlatform.features.monitoring.title': 'Monitoreo de Salud',
  'healthPlatform.features.monitoring.desc': 'Monitoreo continuo de la salud del paciente y alertas',
  'healthPlatform.benefits.title': 'Beneficios de Atención al Paciente',
  'healthPlatform.benefits.subtitle': 'Ofreciendo experiencias de atención médica superiores',
  'healthPlatform.benefits.patientSatisfaction.title': 'Satisfacción del Paciente',
  'healthPlatform.benefits.patientSatisfaction.desc': 'Experiencia mejorada del paciente mediante coordinación de atención fluida',
  'healthPlatform.benefits.patientSatisfaction.label': 'Tasa de Satisfacción',
  'healthPlatform.benefits.accessibility.title': 'Acceso a la Atención Médica',
  'healthPlatform.benefits.accessibility.desc': 'Acceso las 24 horas a servicios e información de atención médica',
  'healthPlatform.benefits.accessibility.label': 'Disponibilidad',
  'healthPlatform.benefits.waitTime.title': 'Reducción de Tiempos de Espera',
  'healthPlatform.benefits.waitTime.desc': 'La programación optimizada reduce significativamente los tiempos de espera de los pacientes',
  'healthPlatform.benefits.waitTime.label': 'Reducción de Tiempo',
  'healthPlatform.cta.title': 'Eleve su Atención al Paciente',
  'healthPlatform.cta.subtitle': 'Únase a instituciones sanitarias que ofrecen experiencias excepcionales a los pacientes',
  'healthPlatform.cta.button': 'Comenzar',

  // Enterprise Platform
  'enterprisePlatform.hero.title': 'Plataforma de Gestión Empresarial',
  'enterprisePlatform.hero.subtitle': 'Plataforma robusta de nivel empresarial para gestionar operaciones, flujos de trabajo y recursos sanitarios complejos con inteligencia empresarial integral',
  'enterprisePlatform.hero.exploreFeatures': 'Explorar Características',
  'enterprisePlatform.hero.contactUs': 'Contáctenos',
  'enterprisePlatform.features.title': 'Características Empresariales',
  'enterprisePlatform.features.subtitle': 'Gestión empresarial completa para empresas sanitarias',
  'enterprisePlatform.features.orgManagement.title': 'Gestión Organizacional',
  'enterprisePlatform.features.orgManagement.desc': 'Estructura organizacional jerárquica y gestión de departamentos',
  'enterprisePlatform.features.financial.title': 'Gestión Financiera',
  'enterprisePlatform.features.financial.desc': 'Planificación financiera, presupuestación e informes integrales',
  'enterprisePlatform.features.hr.title': 'Recursos Humanos',
  'enterprisePlatform.features.hr.desc': 'Gestión completa de RRHH incluyendo personal, programación y rendimiento',
  'enterprisePlatform.features.reporting.title': 'Inteligencia Empresarial',
  'enterprisePlatform.features.reporting.desc': 'Informes y análisis avanzados para la toma de decisiones estratégicas',
  'enterprisePlatform.features.workflow.title': 'Automatización de Flujos de Trabajo',
  'enterprisePlatform.features.workflow.desc': 'Automatice procesos empresariales complejos y flujos de trabajo de aprobación',
  'enterprisePlatform.features.security.title': 'Seguridad Empresarial',
  'enterprisePlatform.features.security.desc': 'Seguridad multicapa con control de acceso basado en roles',
  'enterprisePlatform.benefits.title': 'Beneficios Empresariales',
  'enterprisePlatform.benefits.subtitle': 'Impulse la excelencia y el crecimiento empresarial',
  'enterprisePlatform.benefits.productivity.title': 'Productividad del Equipo',
  'enterprisePlatform.benefits.productivity.desc': 'Empodere a los equipos con herramientas eficientes y flujos de trabajo automatizados',
  'enterprisePlatform.benefits.productivity.label': 'Aumento de Productividad',
  'enterprisePlatform.benefits.integration.title': 'Integración de Sistemas',
  'enterprisePlatform.benefits.integration.desc': 'Conéctese con sistemas empresariales existentes y servicios de terceros',
  'enterprisePlatform.benefits.integration.label': 'Integraciones',
  'enterprisePlatform.benefits.roi.title': 'Retorno de Inversión',
  'enterprisePlatform.benefits.roi.desc': 'Maximice el ROI mediante excelencia operativa y optimización de costos',
  'enterprisePlatform.benefits.roi.label': 'Aumento de ROI',
  'enterprisePlatform.cta.title': 'Optimice su Empresa',
  'enterprisePlatform.cta.subtitle': 'Experimente el poder de la gestión empresarial integrada',
  'enterprisePlatform.cta.button': 'Solicitar Consulta',
};